export default {
  teams: [],
  teamLoader: false,
};

